import { IsNotEmpty, IsString } from 'class-validator';

class GetReceiptUrlsBodyDto {
  @IsNotEmpty()
  @IsString({ each: true })
  receiptIds!: string[];
  @IsNotEmpty()
  @IsString()
  tenant!: string;
}

class GetUploadUrlBodyDto {
  @IsNotEmpty()
  @IsString()
  tenant!: string;
  @IsNotEmpty()
  @IsString()
  fileType!: string;
  @IsNotEmpty()
  @IsString()
  md5Hash!: string;
}

export const ServiceProviderReceiptUploadControllerDefinition = {
  controller: 'receipt-image',
  endpoints: {
    getReceiptUrls: {
      method: 'POST',
      url: 'multi',
      response: undefined as unknown as { [key: string]: string | undefined },
      body: undefined as unknown as GetReceiptUrlsBodyDto,
      query: undefined,
    },
    getUploadUrl: {
      method: 'POST',
      url: ':id',
      response: undefined as unknown as string | undefined,
      body: undefined as unknown as GetUploadUrlBodyDto,
      query: undefined,
    },
  },
} as const;

export type ServiceProviderReceiptUploadControllerResultTypes = {
  [key in keyof (typeof ServiceProviderReceiptUploadControllerDefinition)['endpoints']]: (typeof ServiceProviderReceiptUploadControllerDefinition)['endpoints'][key]['response'];
};
export type ServiceProviderReceiptUploadControllerQueryTypes = {
  [key in keyof (typeof ServiceProviderReceiptUploadControllerDefinition)['endpoints']]: (typeof ServiceProviderReceiptUploadControllerDefinition)['endpoints'][key]['query'];
};
export type ServiceProviderReceiptUploadControllerBodyTypes = {
  [key in keyof (typeof ServiceProviderReceiptUploadControllerDefinition)['endpoints']]: (typeof ServiceProviderReceiptUploadControllerDefinition)['endpoints'][key]['body'];
};
